export default __webpack_public_path__ + "static/media/120.b2d4463d.jpg";